export default function applicationName() {
  if (typeof window !== "undefined" && window.SchoolBridge?.applicationName) {
    return window.SchoolBridge.applicationName;
  }

  return "School Bridge";
}
